export default __webpack_public_path__ + "static/media/balance.8e7a332b.svg";